const SNAPSHOT_DIGITAL_DATA = 'SNAPSHOT_DIGITAL_DATA';

export default {
    SNAPSHOT_DIGITAL_DATA,
};
